import React from "react";

import { Wrapper, Container, TextWrap, Title, Text, Image } from "./style";

import { useSelector } from "react-redux";

const selector = state => ({
  component: state.component
});

export default function NascemosParaFacilitar() {
  const { component: {
    simpleSectionTitle,
    simpleSectionImage,
    simpleSectionDescription,
    simpleSectionBgColor,
    simpleSectionTextColor
  }}  = useSelector(selector);

  return (
    <Wrapper style={{ backgroundColor: simpleSectionBgColor }}>
      <Container>
        <TextWrap>
          <Title color={simpleSectionTextColor}>{simpleSectionTitle}</Title>
          <Text color={simpleSectionTextColor}>{simpleSectionDescription}</Text>
        </TextWrap>
        <Image src={`https://` + simpleSectionImage} />
      </Container>
    </Wrapper>
  );
}
